import stls from '@f_qwep/styles/component/batchPricer/BatchPricerTaskList.module.sass';

export function CellName({ info }: any) {
    return (
        <div className={stls.cellName}>
            <p className={stls.cellName}>{info.row.original.taskName}</p>
        </div>
    );
}
